import { getLocalizedPath } from "../config";

export interface HreflangUrls {
    fi: string;
    en: string;
    sv: string;
}

export function useHreflang(routeKey: string): HreflangUrls {
    const baseUrl = process.env.REACT_APP_SITE_URL || "https://digihappy.fi";

    return {
        fi: `${baseUrl}${getLocalizedPath(routeKey, "fi")}`,
        en: `${baseUrl}${getLocalizedPath(routeKey, "en")}`,
        sv: `${baseUrl}${getLocalizedPath(routeKey, "sv")}`,
    };
}
